import {Component,ReactElement} from 'react';

export namespace basic
{
  
    export interface Props
    {
        className?:string,
        style?:object,
        children?:JSX.Element|string|(JSX.Element|null[])
    }

    export function getBasic(props:Props):[string,object]
    {
        var style=props.style!==undefined?{...props.style}:{};
        var className=props.className!==undefined?props.className:"";

        return [className,style];
    }


   /* export function thisMaker<Tprops,Tstate>(component:{(props:Tprops,saveState:SaveState<Tstate>):JSX.Element}){
       
        var saveState:SaveState<Tstate>={
            state:null
        }

        return (props:Tprops)=>{

            return component(props,saveState);
        };
    }*/
}

